import { Component, ViewChild, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { HelperService } from '@app/core/services';

@Component({
  selector: 'ecp-bulk-order-details-table',
  templateUrl: './bulk-order-details-table.component.html',
  styleUrls: ['./bulk-order-details-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class BulkOrderDetailsTableComponent {
  @Input() mappedOrderList: any;
  @ViewChild('outerSort', { static: true }) sort: MatSort;
  @ViewChild('outerPaginate', { static: true }) paginator: MatPaginator;

  dataSource = new MatTableDataSource(null);
  columnsToDisplay = ['shipToAccountNumber', 'upc', 'jobtype', 'orderType', 'patientName', 'rxId', 'status'];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  expandOrder: any | null;

  constructor(private helper: HelperService) {}

  ngOnChanges() {
    this.dataSource = new MatTableDataSource(this.mappedOrderList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  orderCheck(order) {
    return this.helper.interumOrderRow(order);
  }
  useCheck(order) {
    return this.helper.checkLineUseType(order);
  }
  forBoardCheck(order) {
    return this.helper.checkIfForBoard(order);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
